import * as React from "react";
const SvgFiRrFaceConfounded = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-confounded_svg__a)">
      <path
        fill="#062147"
        d="M13 9c0-.334.167-.646.445-.832l3-2a1 1 0 1 1 1.11 1.664L15.803 9l1.752 1.168a1 1 0 1 1-1.11 1.664l-3-2A1 1 0 0 1 13 9m-6.832 2.555a1 1 0 0 0 1.387.277l3-2a1 1 0 0 0 0-1.664l-3-2a1 1 0 1 0-1.11 1.664L8.197 9l-1.752 1.168a1 1 0 0 0-.277 1.387m13.529 2.727a1 1 0 0 0-1.414.023l-1.432 1.479-1.365-1.352a1.51 1.51 0 0 0-2.11.002l-1.375 1.362-1.377-1.364a1.51 1.51 0 0 0-2.109.002l-1.364 1.35-1.432-1.479a1 1 0 0 0-1.437 1.391l1.789 1.848c.28.288.527.453.93.457.398 0 .915-.159 1.198-.439l1.371-1.357 1.377 1.363a1.496 1.496 0 0 0 2.111 0l1.376-1.363 1.371 1.357c.283.28.798.439 1.196.439.402-.004.651-.169.935-.46l1.786-1.845a1 1 0 0 0-.023-1.414zM24 12.001c0 6.617-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0s12 5.383 12 12zm-2 0c0-5.514-4.486-10-10-10S2 6.486 2 12s4.486 10 10 10 10-4.486 10-10z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-confounded_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceConfounded;
